/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{ count: NonNullable<unknown> }} Plan_Build_Builder_CountInputs */

const en_us2_plan_build_builder_count = /** @type {(inputs: Plan_Build_Builder_CountInputs) => LocalizedString} */ (i) => {
	if ((i?.count === 0 || i?.count === "0")) return /** @type {LocalizedString} */ (`No exercises yet`);
	if ((i?.count === 1 || i?.count === "1")) return /** @type {LocalizedString} */ (`1 exercise in the workout`);
	return /** @type {LocalizedString} */ (`${i?.count} exercises in the workout`)
	
};

const pt_br2_plan_build_builder_count = /** @type {(inputs: Plan_Build_Builder_CountInputs) => LocalizedString} */ (i) => {
	if ((i?.count === 0 || i?.count === "0")) return /** @type {LocalizedString} */ (`Nenhum exercício ainda`);
	if ((i?.count === 1 || i?.count === "1")) return /** @type {LocalizedString} */ (`1 exercício no treino`);
	return /** @type {LocalizedString} */ (`${i?.count} exercícios no treino`)
	
};

const es_419_plan_build_builder_count = /** @type {(inputs: Plan_Build_Builder_CountInputs) => LocalizedString} */ (i) => {
	if ((i?.count === 0 || i?.count === "0")) return /** @type {LocalizedString} */ (`Todavía no hay ejercicios`);
	if ((i?.count === 1 || i?.count === "1")) return /** @type {LocalizedString} */ (`1 ejercicio en el entrenamiento`);
	return /** @type {LocalizedString} */ (`${i?.count} ejercicios en el entrenamiento`)
	
};

const pt_pt2_plan_build_builder_count = /** @type {(inputs: Plan_Build_Builder_CountInputs) => LocalizedString} */ (i) => {
	if ((i?.count === 0 || i?.count === "0")) return /** @type {LocalizedString} */ (`Ainda nenhum exercício`);
	if ((i?.count === 1 || i?.count === "1")) return /** @type {LocalizedString} */ (`1 exercício no treino`);
	return /** @type {LocalizedString} */ (`${i?.count} exercícios no treino`)
	
};

const fr_fr2_plan_build_builder_count = /** @type {(inputs: Plan_Build_Builder_CountInputs) => LocalizedString} */ (i) => {
	if ((i?.count === 0 || i?.count === "0")) return /** @type {LocalizedString} */ (`Aucun exercice pour l'instant`);
	if ((i?.count === 1 || i?.count === "1")) return /** @type {LocalizedString} */ (`1 exercice dans la séance`);
	return /** @type {LocalizedString} */ (`${i?.count} exercices dans la séance`)
	
};

const de_de2_plan_build_builder_count = /** @type {(inputs: Plan_Build_Builder_CountInputs) => LocalizedString} */ (i) => {
	if ((i?.count === 0 || i?.count === "0")) return /** @type {LocalizedString} */ (`Noch keine Übungen`);
	if ((i?.count === 1 || i?.count === "1")) return /** @type {LocalizedString} */ (`1 Übung im Training`);
	return /** @type {LocalizedString} */ (`${i?.count} Übungen im Training`)
	
};

const it_it2_plan_build_builder_count = /** @type {(inputs: Plan_Build_Builder_CountInputs) => LocalizedString} */ (i) => {
	if ((i?.count === 0 || i?.count === "0")) return /** @type {LocalizedString} */ (`Ancora nessun esercizio`);
	if ((i?.count === 1 || i?.count === "1")) return /** @type {LocalizedString} */ (`1 esercizio nell'allenamento`);
	return /** @type {LocalizedString} */ (`${i?.count} esercizi nell'allenamento`)
	
};

/**
* | count | output |
* | --- | --- |
* | "0" | "No exercises yet" |
* | "1" | "1 exercise in the workout" |
* | * | "{count} exercises in the workout" |
*
* @param {Plan_Build_Builder_CountInputs} inputs
* @param {{ locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }} options
* @returns {LocalizedString}
*/
const plan_build_builder_count = /** @type {((inputs: Plan_Build_Builder_CountInputs, options?: { locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Plan_Build_Builder_CountInputs, { locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }, {}>} */ ((inputs, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "pt-BR") return pt_br2_plan_build_builder_count(inputs)
	if (locale === "es-419") return es_419_plan_build_builder_count(inputs)
	if (locale === "pt-PT") return pt_pt2_plan_build_builder_count(inputs)
	if (locale === "fr-FR") return fr_fr2_plan_build_builder_count(inputs)
	if (locale === "de-DE") return de_de2_plan_build_builder_count(inputs)
	if (locale === "it-IT") return it_it2_plan_build_builder_count(inputs)
	return en_us2_plan_build_builder_count(inputs)
});
export { plan_build_builder_count as "plan-build.builder_count" }